import useNetwork from '@/hooks/use-network';
import { Info, WifiOff } from 'lucide-react';

const OfflineWrapper = (props: {
  children: React.ReactNode;
  isToast?: boolean;
}) => {
  const { isOnline } = useNetwork();
  return (
    <>
      {props.children}
      {!isOnline && !props.isToast && (
        <div className="fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 z-10">
          <div className="flex size-full flex-col items-center justify-center">
            <div className="absolute left-1/2 top-1/2 mb-16 -translate-x-1/2 -translate-y-1/2 items-center justify-center text-center ">
              <span className="bg-gradient-to-b from-foreground to-transparent bg-clip-text text-[10rem] font-extrabold leading-none text-transparent">
                Warning!
              </span>
              <h2 className="font-heading my-2 flex items-center justify-center gap-2 text-2xl font-bold w-full">
                <WifiOff className="h-6 w-6" /> Internet connection lost
              </h2>
              <p>Please check your internet connection.</p>
            </div>
          </div>
        </div>
      )}

      {!isOnline && props.isToast && (
        <div className="fixed top-4 right-4 bg-slate-200 p-2 px-4 rounded-lg z-[300]">
          <div className="flex items-center gap-2">
            <Info className="h-8 w-8" />
            <div>
              <p className="text-lg text-black">Offline</p>
              <p className="text-md text-black">
                Please check your internet connection.
              </p>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default OfflineWrapper;
